import template from './am-group-view.html';
import { Paging, Assetsfilter } from '../../core/models/am-helper.model';
import { pollOnInterval } from '../../core/utilities/am-helper.util';

class AmGroupViewComponent {
  constructor(amGroupsService, amAssetsService, $stateParams, $state, $interval) {
    'ngInject';
    this.groupService = amGroupsService;
    this.assetService = amAssetsService;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.status = '';
    this.editMode = '';
    this.onLoadErrorFlag = false;
    this.group = {};
    // Pagination
    this.total = null;
    this.filter = new Assetsfilter();
    this.paging = new Paging(15, 1);
    this.interval = $interval;

    this.updatedGroup = {};
  }

  $onInit() {
    this.status = 'loading';
    this.group.id = this.$stateParams.id;
    this.getGroupData().then(() => {
      this.updateInterval = pollOnInterval(this.interval, () => this.getGroupData());
    });

    if (!this.group.assets) this.group.assets = [];
  }

  $onChanges() { }

  $onDestroy() {
    if (this.updateInterval) {
      this.interval.cancel(this.updateInterval);
    }
  }

  getGroupData() {
    return this.assetService.getAssetsByGroupId(this.group.id).then(result => {
      this.group.assets = result.assets || [];
      this.group.name = result.name || '';
      this.group.email = result.email || '';
      this.group.createdAt = result.createdAt || '';
      this.group.attrs = result.attrs || {};
      this.status = '';
      this.onLoadErrorFlag = false;
    }).catch(() => {
      this.onLoadErrorFlag = true;
    });
  }

  showEditForm() {
    this.editMode = true;
  }

  cancelEdit() {
    this.editMode = false;
  }

  hasAssets() {
    return this.group.assets.length !== 0;
  }

  updateGroupMetaData(updatedGroup) {
    if (!updatedGroup.name) return;
    this.group.name = updatedGroup.name;
    this.status = 'updating';
    this.groupService
      .updateGroupMetadata(this.group.id, this.group)
      .then(() => {
        this.status = '';
        this.cancelEdit();
      })
      .catch(error => {
        this.status = 'error';
        this.statusCode = error.status;
      });
  }

  addAssets(assets) {
    this.updateGroupAssets(assets, 'add');
    this.group.assets = this.group.assets.concat(assets);
  }
  removeAssets(assets) {
    this.updateGroupAssets(assets, 'remove');
    this.group.assets = this.group.assets.filter(
      asset => assets.findIndex(selected => selected.id === asset.id) === -1
    );
  }
  updateGroupAssets(updateAssets, operation) {
    if (!this.group.assets) return;
    // Set status
    this.status = 'uploading';

    // Call the service to update the assets
    this.groupService
      .updateGroupAssets(this.group.id, updateAssets, operation)
      .then(() => {
        this.status = '';
        // this.group.assets = angular.copy(resultAssets);
      })
      .catch(() => {
        this.status = 'error';
      });
  }
  confirmThenDelete() {
    this.groupService
      .openDeleteGroupPopup(this.group)
      .then(() => {
        this.$state.go('access-management.group-list');
      })
      .catch(() => { });
  }
  viewAsset(asset) {
    if (asset) {
      this.$state.go('access-management.asset-view', {
        id: asset.id
      });
    }
  }
  groupHasEmail() {
    return this.group && this.group.email != null && this.group.email !== "";
  }
}

export default {
  template,
  controller: AmGroupViewComponent,
  controllerAs: 'groupVm',
  bindings: {}
};
